import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  ImageBlock as StyledImageBlock,
  ImageCaption,
  OverlayTextBlock,
} from '../../styles/LongreadBlockRenderer.styles';
import { invertColor } from '../../utils/colorUtils';

interface ImageBlockProps {
  block: any;
  backgroundColor?: string;
}

export const ImageBlockComponent: FC<ImageBlockProps> = ({ block, backgroundColor }) => {
  const hasAttachments = block.attachments && block.attachments.length > 0;
  const firstAttachment = hasAttachments ? block.attachments[0] : null;
  const files = firstAttachment?.files || [];

  const defaultTextColor = useMemo(() => {
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor]);

  return (
    <LongreadBlockWrapper>
      <StyledImageBlock>
        {hasAttachments && <ResizedImageEnhanced files={files} />}
        {block.caption && (
          <ImageCaption textColor={defaultTextColor}>
            <FormatLinkedText text={block.caption} />
          </ImageCaption>
        )}
        {block.text && (
          <OverlayTextBlock textColor={defaultTextColor} hasCaption={!!block.caption}>
            <FormatLinkedText text={block.text} />
          </OverlayTextBlock>
        )}
      </StyledImageBlock>
    </LongreadBlockWrapper>
  );
};
import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  ImageBlock as StyledImageBlock,
  ImageCaption,
  OverlayTextBlock,
} from '../../styles/LongreadBlockRenderer.styles';
import { invertColor } from '../../utils/colorUtils';

interface ImageBlockProps {
  block: any;
  backgroundColor?: string;
}

export const ImageBlockComponent: FC<ImageBlockProps> = ({ block, backgroundColor }) => {
  const hasAttachments = block.attachments && block.attachments.length > 0;
  const firstAttachment = hasAttachments ? block.attachments[0] : null;
  const files = firstAttachment?.files || [];

  const defaultTextColor = useMemo(() => {
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor]);

  return (
    <LongreadBlockWrapper>
      <StyledImageBlock>
        {hasAttachments && <ResizedImageEnhanced files={files} />}
        {block.caption && (
          <ImageCaption textColor={defaultTextColor}>
            <FormatLinkedText text={block.caption} />
          </ImageCaption>
        )}
        {block.text && (
          <OverlayTextBlock textColor={defaultTextColor} hasCaption={!!block.caption}>
            <FormatLinkedText text={block.text} />
          </OverlayTextBlock>
        )}
      </StyledImageBlock>
    </LongreadBlockWrapper>
  );
};
